/**
 * Manager Route Utility
 * Maps role_id (from localStorage user.role.id) to the correct manager route prefix
 * Uses existing user data from localStorage - no additional saves needed
 */

const roleRouteMap = {
  2: 'carehome-manager',      // Care Home Manager (role_id 2)
  4: 'carehome-manager',      // Domiciliary Manager (role_id 4) - Now using common manager routes
};

/**
 * Get the manager route prefix based on role_id from user in localStorage
 * @returns {string} - Route prefix without leading/trailing slashes
 */
export const getManagerRoutePath = () => {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const roleId = user?.role?.id || 2;
    return roleRouteMap[roleId] || 'carehome-manager';
  } catch (error) {
    console.error('Error parsing user from localStorage:', error);
    return 'carehome-manager';
  }
};

export default {
  getManagerRoutePath,
};
